import axios from "axios";
import request from "../../request";
import { browserName, browserVersion } from "react-device-detect";

export const finalizeLogin = async (userData, dispatch, token) => {
  if (token) {
    localStorage.setItem("token", token);
  }
  dispatch({
    type: "SET_USER",
    user: userData,
  });
  // localStorage.setItem("user", `${userData.firstname} ${userData.lastname}`);
  localStorage.setItem("user", userData.email);
  localStorage.setItem('cookiespop', true);
  localStorage.setItem("userdata", JSON.stringify(userData));
  localStorage.setItem(
    "address",
    JSON.stringify(userData.addresses)
  );
  localStorage.setItem("userid", userData.id);
  localStorage.setItem(
    "username",
    `${userData.firstname} ${userData.lastname}`
  );
  localStorage.setItem(
    "companyid",
    `${userData.extension_attributes.aw_ca_company_user.company_id}`
  );
  localStorage.setItem(
    "company_group_id",
    `${userData.extension_attributes.aw_ca_company_user.company_group_id}`
  );
  localStorage.setItem(
    "company_role_id",
    `${userData.extension_attributes.aw_ca_company_user.company_role_id}`
  );

  await getroles();

  // Clean up temp data
  localStorage.removeItem("tempUserData");
  localStorage.removeItem("otpRequestToken");

  // Redirect after login
  const redirectPath = localStorage.getItem("redirectAfterLogin");
  if (redirectPath) {
    window.location.href = redirectPath;
    localStorage.removeItem("redirectAfterLogin");
  } else if (localStorage.getItem('isCustMigrateLogin') === 'true') {
    window.location.href = "/changepassword";
  } else {
    window.location.href = "/";
  }
};

export const CHECKTERMS = (dispatch, userid, history, setShow) => {
  let TOKEN = localStorage.getItem('token')
  async function checkTerms() {
    if (userid !== null) {
      try {
        const data = await axios({
          method: 'get',
          url: `${request?.getTerms}${userid}`,
          headers: {
            "Authorization": `Bearer ${TOKEN}`,
          },
        });
        if (data?.data[0]?.termsConditionStatus == "0") {
          setShow(true);
          // console.log(data?.data, 'DATA1234')
        } else {
          history.push("/");
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  checkTerms();
}

export const AGREETERMS = (dispatch, history, browserName, browserVersion) => {
  let TOKEN = localStorage.getItem('token')
  async function agreeterms() {
    try {
      await axios({
        method: 'post',
        url: `${request?.setTerms}${localStorage.getItem('userid')}`,
        headers: {
          "Authorization": `Bearer ${TOKEN}`,
        },
      });
      AGREETERMSLOG(browserName, browserVersion);
      const tempLoginDataString = localStorage.getItem('tempLoginData');
      if (tempLoginDataString) {
        const tempLoginData = JSON.parse(tempLoginDataString);
        finalizeLogin(tempLoginData.userData, dispatch, tempLoginData.token);
        localStorage.removeItem('tempLoginData');
      } else {
        history.push("/");
      }
    } catch (e) {
      console.log(e)
    }
  }
  agreeterms()
}

export const AGREETERMSLOG = (browserName, browserVersion) => {
  let TOKEN = localStorage.getItem('token')
  let customercode = JSON.parse(localStorage.getItem("userdata"));
  async function agreetermslog() {
    try {
      const res = await axios.get("https://geolocation-db.com/json/");
      await axios({
        method: "post",
        url: request.logTerms,
        headers: {
          "Authorization": `Bearer ${TOKEN}`,
        },
        data: {
          data: {
            customer_id: localStorage.getItem("userid"),
            company_id: localStorage.getItem("companyid"),
            customer_code: customercode?.extension_attributes?.customer_code,
            remote_ip: res.data.IPv4,
            user_agent: `${browserName} Version:${browserVersion}`,
            action: "accept the terms & condition",
            action_type: "save",
            functioncall_url: "user/save/",
          }
        }
      })
    } catch (e) {
      console.log(e)
    }
  }
  agreetermslog()
}

export const FORGOTPASSWORD = (toast, dispatch, getEmail, setEmailModalValidation, setGetEmail, setEmailModal) => {
  async function forgorpassword() {
    if (getEmail.match(/^(([^<>()[\]\\,;:\s@"]+(\.[^<>()[\]\\,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) === null) {
      setEmailModalValidation("Invalid Email Address")
    } else {
      dispatch({
        type: "LOADER__TRIGGER",
        status: true
      });
      try {
        setEmailModalValidation("")
        const data = await axios({
          method: 'POST',
          url: request.forgotPassword,
          data: {
            data: {
              email: getEmail
            }
          }
        })
        if (data?.data[0]?.status) {
          setEmailModal(false)
          setGetEmail("")
          dispatch({
            type: "LOADER__TRIGGER",
            status: false
          });
          return toast.success(`${data?.data[0]?.message}`)
        }
      } catch (e) {
        dispatch({
          type: "LOADER__TRIGGER",
          status: false
        });
        console.log(e)
      }
    }
  }
  forgorpassword()
}

export const LOGINUSERINFO = (dispatch, username, password, toast, history, setShow) => {
  async function loginuserinfo() {
    try {
      const tokenResponse = await axios({
        method: "post",
        url: request.userLogin,
        data: {
          username: username,
          password: password,
        },
      });
      const token = tokenResponse.data;
      if (token[0].status == false) {
        return toast.error(`${token[0].message}`)
      }
      localStorage.setItem("token", token);
      localStorage.setItem("user", username);
      //  Mark as social login false
      localStorage.setItem("isSocialLogin", "false");

      if (token) {
        try {
          const userDataResponse = await axios({
            method: "get",
            url: request.userData,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          const userData = userDataResponse.data;
          localStorage.setItem("userid", userData.id);

          // Check terms right here
          try {
            const termsData = await axios({
              method: 'get',
              url: `${request?.getTerms}${userData.id}`,
              headers: { "Authorization": `Bearer ${token}` },
            });

            if (termsData?.data[0]?.termsConditionStatus == "0") {
              // Terms not accepted, show popup.
              const tempLoginData = { userData, token };
              localStorage.setItem('tempLoginData', JSON.stringify(tempLoginData));
              setShow(true);
            } else {
              // Terms accepted, finalize login.
              finalizeLogin(userData, dispatch, token);
            }
          } catch (termsError) {
            console.error("Error checking terms, proceeding with login", termsError);
            finalizeLogin(userData, dispatch, token);
          }
        } catch (e) {
          console.error("Error getting user data:", e);
          if (e.response?.data?.message === "The consumer isn't authorized to access %resources.") {
            ["token", "userid", "userdata", "address", "defaultBranchId", "cartid", "user", "companyid", "companyrolesdata", "company_role_id", "company_group_id", "timer"]
              .forEach(key => localStorage.removeItem(key));
          }
        }
      } else {
        getroles();
      }

    } catch (e) {
      console.log(e)
    }
  }
  loginuserinfo()
}

export const VERIFY_OTP_AND_LOGIN = (dispatch, otp, history, toast) => {
  async function verifyOtp() {
    dispatch({ type: "LOADER__TRIGGER", status: true });
    try {
      const otpRequestToken = localStorage.getItem('otpRequestToken');
      const tempUserData = JSON.parse(localStorage.getItem('tempUserData'));

      if (!otpRequestToken || !tempUserData) {
        toast.error('Session expired or invalid. Please log in again.');
        history.push('/login');
        return;
      }

      const response = await axios({
        method: "post",
        url: request.verifyOTP,
        data: {
          // As per the example, send the token from the request-OTP step
          token: otpRequestToken,
          otp: otp
        },
        headers: {
          accept: "*/*",
          "Content-Type": "application/json",
        },
      });
      if (response?.data?.status === "success") {
        toast.success('Login successful!');

        const userData = await axios({
          method: "get",
          url: request.userData,
          headers: {
            Authorization: `Bearer ${tempUserData.token}`,
          },
        });

        finalizeLogin(userData.data, dispatch, tempUserData.token);
      } else {
        toast.error(response?.data?.message || 'Invalid OTP. Please try again.');
      }
    } catch (error) {
      console.error("Verify OTP call failed:", error);
      toast.error('An error occurred during OTP verification.');
    } finally {
      dispatch({ type: "LOADER__TRIGGER", status: false });
    }
  }
  verifyOtp();
}

export const TOKENUSERINFO = (dispatch, token, history, setShow, options = {}) => {
  async function userinfo() {
    const { checkTerms = false } = options;
    try {
      if (token) {
        try {
          // Set token early for subsequent API calls
          localStorage.setItem("token", token);
          localStorage.setItem("isSocialLogin", "true");

          const userDataResponse = await axios({
            method: "get",
            url: request.userData,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          const userData = userDataResponse.data;
          localStorage.setItem("userid", userData.id);

          if (checkTerms) {
            // Check terms right here
            try {
              const termsData = await axios({
                method: 'get',
                url: `${request?.getTerms}${userData.id}`,
                headers: { "Authorization": `Bearer ${token}` },
              });

              if (termsData?.data[0]?.termsConditionStatus == "0") {
                // Terms not accepted, show popup.
                const tempLoginData = { userData, token };
                localStorage.setItem('tempLoginData', JSON.stringify(tempLoginData));
                if (setShow) {
                  setShow(true);
                } else {
                  // Coming from a page without the modal (e.g., LineCallback)
                  // Redirect to login page to show the modal there.
                  localStorage.setItem('showTermsOnLoad', 'true');
                  history.replace('/login');
                }
              } else {
                // Terms accepted, finalize login.
                finalizeLogin(userData, dispatch, token);
              }
            } catch (termsError) {
              console.error("Error checking terms, proceeding with login", termsError);
              finalizeLogin(userData, dispatch, token);
            }
          } else {
            // If not checking terms, just finalize the login
            finalizeLogin(userData, dispatch, token);
          }
        } catch (e) {
          console.error("Error getting " + e)
          if (e.response?.data?.message === "The consumer isn't authorized to access %resources.") {
            ["token", "userid", "userdata", "address", "defaultBranchId", "cartid", "user", "companyid", "companyrolesdata", "company_role_id", "company_group_id", "timer"].forEach(key => localStorage.removeItem(key));
            window.location.href = '/login'; // Redirect to login on auth error
          }
        }
      }
    } catch (e) {
      console.log(e)
    }
  }
  userinfo()
}

const getroles = async () => {
  if (localStorage.getItem("companyid") === null) return;
  try {
    const rolesdata = await axios({
      method: "get",
      url: `${request.allroles
        }?searchCriteria[filterGroups][0][filters][0][field]=company_id&searchCriteria[filterGroups][0][filters][0][value]=${localStorage.getItem(
          "companyid"
        )}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    localStorage.setItem(
      "companyrolesdata",
      JSON.stringify(rolesdata.data.items)
    );
  } catch (e) {
    if (
      e.response?.data?.message ===
      "The consumer isn't authorized to access %resources."
    ) {
      const keysToRemove = [
        "token", "userid", "userdata", "address", "defaultBranchId", "cartid", "user",
        "companyid", "companyrolesdata", "company_role_id", "company_group_id", "timer"
      ];

      keysToRemove.forEach(key => localStorage.removeItem(key));
      // Optionally reload or redirect if needed
      // window.location.reload();
    }
  }
};